import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    onClick() {
        // handler déclaré uniquement pour permettre de définir l' "action option" `:stop` depuis le template
    }
}
